let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cPLJH")).then(() => parcelRequire('kCX5c'));